import {createRouter, createWebHistory} from "vue-router";
import Landing from "../../presentation/pages/landingPage/LandingPage.vue";
import Journey from "../../presentation/pages/journeyPage/AvailableJourney.vue";
import SelectSeat from "../../presentation/pages/journeyPage/SelectSeat.vue";
import MakePayment from "../../presentation/pages/journeyPage/MakePayment.vue";
import Ticket from "../../presentation/pages/journeyPage/Ticket.vue";
import Gallery from "../../presentation/pages/galleryPage/GalleryPage.vue";
import NotFound from "../../presentation/pages/notFoundPage/NotFound.vue";

const router = createRouter({
    mode: "history", // Use 'history' mode to remove the hash from the URL
    history: createWebHistory(),
    // base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.path !== "/") return savedPosition;
        if (to.path === "/") {
            return {top: 0};
        }
        if (to.hash) {
            const el = document.querySelector(to.hash);
            if (el) {
                const y = el.getBoundingClientRect().top + window.scrollY - 80;
                return window.scrollTo({
                    top: y,
                    behavior: "smooth",
                });
            }
        }
        return false;
    },
    routes: [
        {
            path: "/",
            name: "landing",
            component: Landing,
        },
        {
            path: "/journey",
            name: "journey",
            component: Journey,
        },
        {
            path: "/selectSeat",
            name: "selectSeat",
            component: SelectSeat,
        },
        {
            path: "/makePayment",
            name: "makePayment",
            component: MakePayment,
        },
        {
            path: "/ticket",
            name: "ticket",
            component: Ticket,
        },
        {
            path: "/gallery",
            name: "gallery",
            component: Gallery,
        },
        {
            path: "/:pathMatch(.*)*",
            name: "NotFound",
            component: NotFound,
        },
    ],
});

export default router;
